module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/trophy-brigade-lvl3-50.bb9ed5f7.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/trophy-brigade-lvl3-50.png
// module id = 3586
// module chunks = 11